<template>
  <v-main class="pt-0 text-left ml-4 mr-2">
    <v-row>
      <v-col cols="12" class="my-2 font-size--16 font-weight-bold greenIconText">
        <v-icon class="align-self-center mr-2" color="success" :icon="mdiCheckCircle" />
        <p class="align-self-center font-weight-bold">
          {{ $t('L_your_widthdrawal_day_was_successfully_updated') }}
        </p>
      </v-col>
      <v-col cols="12">
        <div class="mb-4">
          {{
            $t('L_your_new_monthly_withdrawal_day_has_been_updated', {
              date: getSelectedDate,
              policy_num: getPolicyNumber,
            })
          }}
        </div>
        <div v-if="dateIssueNextPayDateEarly === 1 || dateIssueNextPayDateEarly === 3">
          {{ $t('L_based_on_your_change_your_current_amount_due_will_be') }}
        </div>
      </v-col>
    </v-row>
    <!-- Button -->
    <v-row class="d-flex align-center justify-end py-4">
      <v-col cols="12" sm="6" md="4" class="pr-4">
        <OnexButton block color="primary" @click="refreshAndClose">
          {{ $t('L_done') }}
        </OnexButton>
      </v-col>
    </v-row>
  </v-main>
</template>

<script lang="ts">
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mdiCheckCircle } from '@mdi/js';
import { mapActions, mapState } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'WDStepThree',
  components: {
    OnexButton,
  },
  props: {
    daySelected: {
      type: String,
      required: true,
      default: '1',
    },
    dateIssueNextPayDateEarly: {
      type: Number,
      required: true,
      default: -1,
    },
    dateForNextPayment: {
      type: String,
      required: true,
      default: '1',
    },
  },
  data: () => ({ mdiCheckCircle }),
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, [
      'policies',
      'currentPolicy',
      'routeNameToNavigateBack',
      'selectedPolicyIndex',
      'withDrawalDateStep',
    ]),
    ...mapState(useGlobalStore, { locale: 'getLocale' }),
    getSelectedDate() {
      let x;
      x = this.daySelected;
      if (this.daySelected === '1' || this.daySelected === '21') {
        x += 'st ';
      } else if (this.daySelected === '2' || this.daySelected === '22') {
        x += 'nd ';
      } else if (this.daySelected === '3' || this.daySelected === '23') {
        x += 'rd ';
      } else {
        x += 'th ';
      }
      return x;
    },
    getPolicyNumber() {
      return this.currentPolicy?.contractId;
    },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    ...mapActions(usePolicyStore, ['getPolicyOverview', 'setWithDrawalDateStep']),
    refreshAndClose() {
      try {
        const i = this.$dynatrace.enterAction('WithdrawalDayConfirmation_Done_Selected');
        this.$dynatrace.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
      this.setWithDrawalDateStep(-1);
      this.$router.push({
        name: RouteNames.POLICY_DETAILS,
        params: { contractId: this.selectedPolicyIndex },
      });
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style>
.greenIconText {
  display: inline-flex;
}
.bg-light-grey {
  background-color: #f5f5f5;
}
.clickable {
  cursor: pointer;
}
.blue_label {
  color: #02579e;
}
.your_withdrawal {
  margin-top: 17px !important;
  padding-left: 10px !important;
}
</style>
